import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
export var NotFound = function () {
    var t = useTranslation(['news']).t;
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "not-found-container", children: _jsxs("div", { className: "content", children: [_jsxs("div", { className: "title mt-2 me-0", children: [" ", t("Aucun résultat de recherche"), " "] }), _jsx("p", { className: "mt-2", children: t("Malheureusement il n'y a pas de résultat selon votre demande. Veuillez essayer un mot-clé.") })] }) }) }));
};
